export const standards = {
  COMMON_CORE: 'COMMON_CORE',
  CALIFORNIA: 'CALIFORNIA',
  BUBBLE_TREE: 'BUBBLE_TREE',
  WEST_VIRGINIA: 'WEST_VIRGINIA',
  PENNSYLVANIA: 'PENNSYLVANIA',
} as const;

//TODO: unify this
export const STANDARD_OPTIONS = [
  { value: 'BUBBLE_TREE', label: 'Bubble Tree' },
  { value: 'COMMON_CORE', label: 'Common Core' },
  { value: 'NEW_JERSEY', label: 'New Jersey' },
  { value: 'WEST_VIRGINIA', label: 'West Virginia' },
  { value: 'PENNSYLVANIA', label: 'Pennsylvania' },
  { value: 'CALIFORNIA', label: 'California' },
  { value: 'ILLINOIS', label: 'Illinois' },
  { value: 'QA_STANDARD', label: 'QA_STANDARD' },
];

export type Standard = keyof typeof standards;

export const getStandardByRegion = (region: string): Standard => {
  if (region === 'US') return standards.COMMON_CORE;
  if (region === 'US-EDR') return standards.CALIFORNIA;
  return standards.BUBBLE_TREE;
};
